import mergeConfig from '../merge-config';

const config = mergeConfig({
  footer: {
    banner125YearsArvesta: false,
  },
});

export default config;
